<div class="-mx-5 overflow-x-auto sm:-mx-6">
  <table class="w-full min-w-[46rem] text-left text-sm">
    <thead>
      <tr class="border-y border-gray-200 bg-gray-50 text-gray-500 dark:border-gray-800 dark:bg-white/[0.02] dark:text-gray-400">
        <th scope="col" class="py-2.5 pl-5 pr-3 font-medium sm:pl-6">Fecha</th>
        <th scope="col" class="px-3 py-2.5 font-medium">Cliente</th>
        <th scope="col" class="px-3 py-2.5 font-medium">Servicio</th>
        @if (showProfessional) {
          <th scope="col" class="px-3 py-2.5 font-medium">Profesional</th>
        }
        <th scope="col" class="px-3 py-2.5 font-medium">Estado</th>
        <th scope="col" class="px-3 py-2.5 text-right font-medium">Valor</th>
        <th scope="col" class="py-2.5 pl-3 pr-5 font-medium sm:pr-6">Pago</th>
      </tr>
    </thead>
    <tbody class="divide-y divide-gray-100 dark:divide-gray-800" [class.opacity-50]="loading" [attr.aria-busy]="loading">
      @for (r of rows; track r.id) {
        <tr class="align-top">
          <td class="whitespace-nowrap py-3 pl-5 pr-3 sm:pl-6">
            <span class="block font-medium capitalize text-gray-800 dark:text-gray-200">{{ r.day }}</span>
            <span class="text-gray-500 dark:text-gray-400">{{ r.time }}</span>
          </td>
          <td class="px-3 py-3 text-gray-800 dark:text-gray-200">{{ r.client }}</td>
          <td class="px-3 py-3 text-gray-600 dark:text-gray-300">{{ r.service }}</td>
          @if (showProfessional) {
            <td class="px-3 py-3 text-gray-600 dark:text-gray-300">{{ r.professional }}</td>
          }
          <td class="whitespace-nowrap px-3 py-3">
            <span class="inline-flex items-center gap-1.5 text-gray-700 dark:text-gray-300">
              <span class="h-2 w-2 rounded-full" [style.background-color]="r.statusColor" aria-hidden="true"></span>
              {{ r.statusLabel }}
            </span>
          </td>
          <td class="whitespace-nowrap px-3 py-3 text-right font-medium text-gray-900 tabular-nums dark:text-white">{{ r.price }}</td>
          <td class="whitespace-nowrap py-3 pl-3 pr-5 sm:pr-6">
            @if (r.paid) {
              <span class="text-success-700 dark:text-success-400">Pagado</span>
            } @else {
              <span class="text-gray-500 dark:text-gray-400">Sin pagar</span>
            }
          </td>
        </tr>
      } @empty {
        <tr>
          <td [attr.colspan]="showProfessional ? 7 : 6" class="px-6 py-10 text-center text-gray-500 dark:text-gray-400">
            @if (loading) {
              Cargando citas…
            } @else if (error) {
              No se pudieron cargar las citas.
              <button type="button" (click)="load()" class="ml-1 font-medium text-brand-600 hover:underline dark:text-brand-400">Reintentar</button>
            } @else {
              No hay citas con estos filtros.
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>

@if (totalCount > pageSize) {
  <nav class="mt-4 flex items-center justify-between gap-3 text-sm" aria-label="Paginación de citas">
    <span class="text-gray-500 tabular-nums dark:text-gray-400">{{ rangeText }}</span>
    <div class="flex items-center gap-2">
      <button type="button" (click)="goTo(page - 1)" [disabled]="page === 1 || loading"
        class="h-9 rounded-lg border border-gray-200 px-3 font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-40 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
        Anterior
      </button>
      <span class="text-gray-500 tabular-nums dark:text-gray-400">{{ page }} / {{ totalPages }}</span>
      <button type="button" (click)="goTo(page + 1)" [disabled]="page === totalPages || loading"
        class="h-9 rounded-lg border border-gray-200 px-3 font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-40 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
        Siguiente
      </button>
    </div>
  </nav>
}
